/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React, { useEffect, useState, useRef } from "react";
import styles from "./SideDrawer.module.css";
import Shimmer from "../../../Shimmer/Shimmer";
import Header from "./../../../Header/Header";
import Card from "./../Card/Card";
import { useSelector, shallowEqual } from "react-redux";
import find from "lodash/find";
import cx from "classnames";
import { Element } from "react-scroll";
import SideDrawerToggler from "./../../../SideDrawerToggler/SideDrawerToggler";
import Filter from "./../Filter/Filter";
import { filterByJobType, filterByUserJob } from "./../../../shared/geofence";
import { toast } from "react-toastify";
import { constant } from "./../../../shared/constants/constants";

const SideDrawer = (props) => {
  const [geofenceState, setGeofenceState] = useState([]);

  const prevGeofenceDataLength = useRef(0);

  const geofenceData = useSelector((state) => state.geofence.geofenceData);
  const jobType = useSelector((state) => state.geoUtil.jobType, shallowEqual);
  const user = useSelector((state) => state.geoUtil.user, shallowEqual);

  useEffect(() => {
    // select default property which came in query params
    // if not then select first property
    if (!props.selectedProperty.propertyId) {
      let defaultSelectedProperty = find(geofenceData, (g) => g.isSelected);
      if (defaultSelectedProperty) {
        props.setProperty(defaultSelectedProperty);
      } else if (geofenceData[0]) {
        props.setProperty(geofenceData[0]);
      }
    } else {
      if (
        geofenceData[0] &&
        props.selectedProperty.propertyId !== geofenceData[0].propertyId &&
        prevGeofenceDataLength.current != geofenceData.length
      ) {
        props.setProperty(geofenceData[0]);
      }
    }
    prevGeofenceDataLength.current = geofenceData.length;
    setGeofenceState(geofenceData);
  }, [geofenceData]);

  // called when any changes happen in job filter
  useEffect(() => {
    // if no job type is selected show all property
    if (jobType === "") {
      if (geofenceState.length === geofenceData.length) return;
      else if (geofenceState.length != geofenceData.length)
        setGeofenceState(geofenceData);
    } else {
      // else filter property by job type
      let data = filterByJobType(geofenceData, jobType);
      if (data.length < 1)
        toast.info(constant.NO_JOBS_AVAILABLE, {
          position: "top-left",
          autoClose: 4000,
        });
      setGeofenceState(data);
    }
  }, [jobType]);

  // called when any changes happen in user filter
  useEffect(() => {
    // if workorder is assigned
    if (jobType === "technician_jobs" || jobType === "contractor_jobs") {
      // if no user is selected filter by job type otherwise filter by user
      if (user.userId === "") {
        let data = filterByJobType(geofenceData, jobType);
        setGeofenceState(data);
      } else {
        let data = filterByUserJob(geofenceData, user.userId);
        if (data.length < 1)
          toast.info(constant.NO_JOBS_AVAILABLE, {
            position: "top-left",
            autoClose: 4000,
          });
        setGeofenceState(data);
      }
    }
  }, [user]);

  return (
    <>
      <SideDrawerToggler
        isSideDrawerVisible={props.isSideDrawerVisible}
        toggleSideDrawer={props.toggleSideDrawer}
      />

      <div
        className={cx(
          styles.SideDrawer,
          props.isSideDrawerVisible ? styles.Open : styles.Close
        )}
        id="scroll-container">
        <Header />
        <Filter />

        <div className={styles.CardCont}>
          {geofenceState.length > 0 ? (
            geofenceState.map((g) => (
              <Element name={g.propertyId} key={g.propertyId}>
                <Card
                  info={g}
                  setProperty={props.setProperty}
                  selectedPropertyId={props.selectedProperty.propertyId}
                  selected={g.propertyId === props.selectedProperty.propertyId}
                  setButtonVisibilityStatus={props.setButtonVisibilityStatus}
                  editButton={props.selectedProperty.button}
                />
              </Element>
            ))
          ) : (
            // <>
            //   <Shimmer />
            //   <Shimmer />
            // </>
            <div className={styles.NoDataFound}>
              <h3>No data found</h3>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const areEqual = (prevProps, nextProps) => {
  return !(
    JSON.stringify(prevProps.selectedProperty) !==
      JSON.stringify(nextProps.selectedProperty) ||
    prevProps.isSideDrawerVisible !== nextProps.isSideDrawerVisible
  );
};
export default React.memo(SideDrawer, areEqual);
